<template>
<el-card>
    <el-collapse accordion>
         <el-collapse-item title="Mailchimp" name="1">
      <button class="btn btn-primary" @click="getActions">Get History</button>
      <br />
      <br />
      <el-timeline>
        <el-timeline-item v-for="(activity, index) in actions" :key="index" :color="activity.color">
          <strong>{{activity.action}}</strong>
          -{{activity.title}}
          {{activity.type}}
          <br />
          {{activity.timestamp | moment('DD/MM/YY')}} -
          <small>{{activity.timestamp | moment("from", "now", true)}} ago</small>
        </el-timeline-item>
      </el-timeline>
      <h4 class="card-title">Mailchimp Profile</h4>
      <button class="btn btn-primary" @click="getMCProfile">View Mailchimp Profile</button>
      <ul v-if="profile" style="list-style-type: none;padding:5px;background-color:#f5f5f5">
        <li v-for="(k,v) in profile">
          <span>
            {{v}}
            <el-tag size="mini" type="success">{{k}}</el-tag>
          </span>
        </li>
      </ul>
       </el-collapse-item>
        </el-collapse>
</el-card>
</template>
<script>


import TimeLine from "./TimeLine.vue";
import TimeLineItem from "./TimeLineItem.vue";
import moment from "moment";
import { mapGetters } from "vuex";


export default {
  props: ["customer"],
  components: {
    TimeLine,
    TimeLineItem
  },
  data() {
    return {
      actions: [],
      profile: []
    };
  },

  computed: {
    ...mapGetters(["getCustomer"]),
    users() {
      return this.$store.getters.getUsers;
    },

    user() {
      return this.$store.getters.getProfile;
    }
  },
  methods: {
    getActions() {
      console.log(this.customer.email);
      const actionsPromise = api.getActions(this.customer.email);

      Promise.resolve(actionsPromise).then(result => {
        console.log(result);
        this.actions = result.data.activity.map(g => {
          g.color = "#" + Math.floor(Math.random() * 16777215).toString(16);
          return g;
        });
      });
    },
    getMCProfile() {
      const profilePromise = api.getMailchimpProfile(this.customer.email);
      Promise.resolve(profilePromise).then(result => {
        for (let [key, value] of Object.entries(result.data.merge_fields)) {
          if (value === "") {
            delete result.data.merge_fields[key];
          }
          if (Object.keys(result.data.merge_fields).length > 0)
            this.profile = result.data.merge_fields;
          else this.profile = { profile: "empty, or not set" };
        }
      });
    }
  },
  mounted() {
    // this.getProducts();
    //  this.initDepartures()
  },
  watch: {
    "$route.params.id": function(id) {
      this.customerID = id;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Customers/CustomerProfile/Actions.vue